export default {
    "name": "HomeSalesOrders",
    "kind": "HoudiniQuery",
    "hash": "dfe924aa5cb451743575594e6211e127dc949629ce6bc77e67bbbb32ba07d26f",

    "raw": `query HomeSalesOrders($filter: SalesOrderFilter) {
  salesOrders(filter: $filter) {
    items {
      store {
        id
      }
      salesOrderId
      date
      billingAddress {
        company
        contact
      }
      balance
      salesperson {
        name
        id
      }
      counterperson {
        name
        id
      }
      total
      documentType {
        name
        id
      }
      purchaseOrderNumber
      shippingMethod {
        name
        id
      }
      truckNumber
      internalComments
      finalized
      totalQuantity
      totalQuantityReady
      id
    }
  }
  salesOrderDocumentTypes {
    name
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "salesOrders": {
                "type": "SalesOrderList",
                "keyRaw": "salesOrders(filter: $filter)",

                "selection": {
                    "fields": {
                        "items": {
                            "type": "SalesOrder",
                            "keyRaw": "items",

                            "selection": {
                                "fields": {
                                    "store": {
                                        "type": "Store",
                                        "keyRaw": "store",

                                        "selection": {
                                            "fields": {
                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "salesOrderId": {
                                        "type": "UInt",
                                        "keyRaw": "salesOrderId",
                                        "visible": true
                                    },

                                    "date": {
                                        "type": "Date",
                                        "keyRaw": "date",
                                        "visible": true
                                    },

                                    "billingAddress": {
                                        "type": "Address",
                                        "keyRaw": "billingAddress",

                                        "selection": {
                                            "fields": {
                                                "company": {
                                                    "type": "String",
                                                    "keyRaw": "company",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "contact": {
                                                    "type": "String",
                                                    "keyRaw": "contact",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "balance": {
                                        "type": "Decimal2",
                                        "keyRaw": "balance",
                                        "visible": true
                                    },

                                    "salesperson": {
                                        "type": "UserAccount",
                                        "keyRaw": "salesperson",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "counterperson": {
                                        "type": "UserAccount",
                                        "keyRaw": "counterperson",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "total": {
                                        "type": "Decimal2",
                                        "keyRaw": "total",
                                        "visible": true
                                    },

                                    "documentType": {
                                        "type": "SalesOrderDocument",
                                        "keyRaw": "documentType",

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "purchaseOrderNumber": {
                                        "type": "String",
                                        "keyRaw": "purchaseOrderNumber",
                                        "visible": true
                                    },

                                    "shippingMethod": {
                                        "type": "ShippingMethod",
                                        "keyRaw": "shippingMethod",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "truckNumber": {
                                        "type": "String",
                                        "keyRaw": "truckNumber",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "internalComments": {
                                        "type": "String",
                                        "keyRaw": "internalComments",
                                        "visible": true
                                    },

                                    "finalized": {
                                        "type": "Boolean",
                                        "keyRaw": "finalized",
                                        "visible": true
                                    },

                                    "totalQuantity": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalQuantity",
                                        "visible": true
                                    },

                                    "totalQuantityReady": {
                                        "type": "Decimal6",
                                        "keyRaw": "totalQuantityReady",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "salesOrderDocumentTypes": {
                "type": "SalesOrderDocument",
                "keyRaw": "salesOrderDocumentTypes",

                "selection": {
                    "fields": {
                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "filter": "SalesOrderFilter"
        },

        "types": {
            "Decimal2Filter": {
                "eq": "Decimal2",
                "gt": "Decimal2",
                "gte": "Decimal2",
                "lt": "Decimal2",
                "lte": "Decimal2"
            },

            "CustomerFilter": {
                "active": "Boolean",
                "balance": "Decimal2Filter",
                "companyName": "String",
                "contactName": "String",
                "email": "String",
                "ids": "UInt",
                "keyword": "String",
                "phoneNumber": "String"
            },

            "DateFilter": {
                "eq": "Date",
                "gt": "Date",
                "gte": "Date",
                "lt": "Date",
                "lte": "Date",
                "ne": "Date"
            },

            "SalesOrderDocumentTypeFilter": {
                "affectsInventory": "Boolean",
                "id": "UInt",
                "name": "String"
            },

            "SalesOrderKey": {
                "salesOrderId": "UInt",
                "storeId": "UInt"
            },

            "SalesOrderFilter": {
                "counterpersonUserId": "UInt",
                "customerFilter": "CustomerFilter",
                "date": "DateFilter",
                "documentTypeFilter": "SalesOrderDocumentTypeFilter",
                "finalized": "Boolean",
                "ids": "SalesOrderKey",
                "isSale": "Boolean",
                "storeId": "UInt",
                "void": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=d2f632e2748f7ff29ce70eb95f7ff93c67d5390e9921babe7a931f2f290f6bf1";